"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueTypes = exports.OperationTypes = void 0;
var OperationTypes;
(function (OperationTypes) {
    OperationTypes["GET"] = "GET";
    OperationTypes["OBSERVE"] = "OBSERVE";
    OperationTypes["UPDATE"] = "UPDATE";
    OperationTypes["REF"] = "REF";
    OperationTypes["FUNC"] = "FUNC";
    OperationTypes["STRUCT"] = "STRUCT";
    OperationTypes["VALUE"] = "VALUE";
    OperationTypes["CONSTRUCTOR"] = "CONSTRUCTOR";
    OperationTypes["PASSTHROUGH"] = "PASSTHROUGH";
})(OperationTypes = exports.OperationTypes || (exports.OperationTypes = {}));
var ValueTypes;
(function (ValueTypes) {
    ValueTypes["CONST"] = "CONST";
    ValueTypes["EXTERNAL"] = "EXTERNAL";
    ValueTypes["INTERNAL"] = "INTERNAL";
    ValueTypes["INVOKE"] = "INVOKE";
})(ValueTypes = exports.ValueTypes || (exports.ValueTypes = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvZHVjZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvcHJvZHVjZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBS0EsSUFBWSxjQVVYO0FBVkQsV0FBWSxjQUFjO0lBQ3hCLDZCQUFXLENBQUE7SUFDWCxxQ0FBbUIsQ0FBQTtJQUNuQixtQ0FBaUIsQ0FBQTtJQUNqQiw2QkFBVyxDQUFBO0lBQ1gsK0JBQWEsQ0FBQTtJQUNiLG1DQUFpQixDQUFBO0lBQ2pCLGlDQUFlLENBQUE7SUFDZiw2Q0FBMkIsQ0FBQTtJQUMzQiw2Q0FBMkIsQ0FBQTtBQUM3QixDQUFDLEVBVlcsY0FBYyxHQUFkLHNCQUFjLEtBQWQsc0JBQWMsUUFVekI7QUFFRCxJQUFZLFVBS1g7QUFMRCxXQUFZLFVBQVU7SUFDcEIsNkJBQWUsQ0FBQTtJQUNmLG1DQUFxQixDQUFBO0lBQ3JCLG1DQUFxQixDQUFBO0lBQ3JCLCtCQUFpQixDQUFBO0FBQ25CLENBQUMsRUFMVyxVQUFVLEdBQVYsa0JBQVUsS0FBVixrQkFBVSxRQUtyQiJ9